export function isPrizePlace(place?: string | null) {
  return Boolean(place && Number(place.split('-')[0]) <= 3);
}

export function formatAchievementPlace(place?: string | null) {
  const p = place ? Number(place?.split('-')[0]) : null;
  return p && p <= 3 ? `${p} место` : 'за участие';
}
